import React, { FC, useMemo } from 'react';
import { UserStatus, userStatusLabelMap } from 'models/userStatus';
import { Tag } from 'antd';
import { TagProps } from 'antd/lib/tag';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

const userStatusColorMap = new Map<UserStatus, TagProps['color'] | undefined>([
  [UserStatus.Active, 'green'],
  [UserStatus.Archived, undefined],
  [UserStatus.WaitingForActivation, 'purple'],
  [UserStatus.NeedPasswordChange, 'orange'],
  [UserStatus.UserPasswordChange, 'orange'],
  [UserStatus.Deactivated, undefined],
  [UserStatus.Inactive, 'purple'],
]);

export interface UserStatusTagProps {
  status: UserStatus;
}

export const UserStatusTag: FC<UserStatusTagProps> = ({ status }) => {
  const intlMessage = useFormatMessage();

  const label = useMemo(
    () => intlMessage({ id: userStatusLabelMap.get(status) ?? status }),

    [status, intlMessage]
  );
  const color = useMemo(
    () => userStatusColorMap.get(status),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [status]
  );

  return (
    <Tag color={color} key={status}>
      {label && label.toUpperCase()}
    </Tag>
  );
};
